import React from "react";
import { useFormContext } from "react-hook-form";
import { IClassDetails } from "repoV2/features/CheckoutPages/utils/apis/SessionDetailsApi/SessionDetailsApi.interface";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import { getSelectedSessionDetailsFieldName } from "../../../../SessionDetailsFormGroup.utils";
import { getClassesRenderData } from "../../utils/getClassesRenderData";

const useSingleSession = (classes: IClassDetails[]) => {
    const [classItem] = classes || [];

    const { setValue } = useFormContext();
    const { listingUuid, listingType } = useCheckoutBasicDetailsContext();

    const { renderSchedultType, renderStartingDate, groupedSlots } =
        getClassesRenderData({ classItem });

    React.useEffect(() => {
        const fieldName = getSelectedSessionDetailsFieldName({
            listingUuid,
            listingType,
        });
        setValue(fieldName, { ...classItem, value: classItem.uuid });
    }, [classItem.uuid]);

    return {
        renderSchedultType,
        renderStartingDate,
        groupedSlots,
    };
};

export default useSingleSession;
